import {Divider, Stack, Typography, useTheme} from '@mui/material';
import React, {Fragment} from 'react';

import Icon from 'presentation/icons';
import {StyledDrawer} from './styles';
import {FormDrawerOrInlineProps} from './types';

export function FormDrawerOrInline({
	title,
	open,
	isMobile,
	onClose,
	children,
}: FormDrawerOrInlineProps) {
	const theme = useTheme();
	if (!open) return null;

	if (isMobile) {
		return (
			<StyledDrawer anchor="right" open={open} onClose={onClose}>
				<Stack
					direction="row"
					alignItems="center"
					gap={1.5}
					p={2}
					sx={{backgroundColor: theme.colors.brand.primary.blue}}>
					<Icon name="arrow-back" onClick={onClose} color={theme.palette.common.white} />
					<Typography variant="h6" fontWeight={600} color={theme.palette.common.white}>
						{title}
					</Typography>
				</Stack>

				<Divider />

				{children}
			</StyledDrawer>
		);
	}

	return (
		<Fragment>
			<Typography variant="body1" fontWeight={600} color="text.primary" mb={1}>
				{title}
			</Typography>

			{children}
		</Fragment>
	);
}
